module.exports = __webpack_public_path__ + "5ba8aa272da004c4872d85c80ceb17fa.jpg";